import {
  APP_ZONES,
  ButtonSizeOptions,
  ButtonTypes,
  GridPosition,
} from '@finxone-platform/shared/sys-config-types';

import { createBackButtonWidget, createQuickLinkWidget, createTextWidget } from '../utils/common-utils';

export const bankStatementsPresetDownloadsWidgets = [
  createTextWidget({
    text: '<h1>EXPORT</h1>',
    configDisplayName: 'Text Widget: EXPORT',
    gridPosition: { y: 1, rows: 2 },
    css_config: {
      color: 'var(--color-on-background-muted)',
      textAlignment: 'left',
      fontSize: 7,
      isTextBold: true,
    },
  }),

  createQuickLinkWidget({
    zone: APP_ZONES.PROFILE,
    navigateToPageUrl: 'bank-statements-custom-date-range',
    navigationOption: 'use-as-navigation',
    text: 'Custom Date Range',
    css_config: {
      color: 'var(--color-primary)',
      backGroundColor: 'transparent',
      fontSize: 16,
      textAlignment: 'right',
      isTextUnderline: true,
    },
    gridPosition: { y: 16, rows: 2 },
    configDisplayName: 'Quick Link: Custom Date Range',
    globalStyling: true,
    globalStylingClass: `${ButtonTypes.PRIMARY} ${ButtonSizeOptions.FULL_WIDTH}`,
  }),
  createBackButtonWidget({ y: 24, rows: 2, cols: 15 } as GridPosition),
];
